const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// Converts legacy plain-text posts ("## " headings, "- " lists) to HTML
export const toHtml = (text) => {
  if (!text || /<\/?[a-z][\s\S]*>/i.test(text)) return text || "";
  return text.split("\n\n").map((block) => {
    const lines = block.split("\n");
    let out = "";
    if (lines[0].startsWith("## ")) out += `<h2>${esc(lines.shift().slice(3))}</h2>`;
    if (!lines.length) return out;
    if (lines.every((l) => l.startsWith("- "))) return out + `<ul>${lines.map((l) => `<li><p>${esc(l.slice(2))}</p></li>`).join("")}</ul>`;
    return out + `<p>${lines.map(esc).join("<br>")}</p>`;
  }).join("");
};
